import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { FontSizes, FontWeights } from '../../utils/typography';
import Button from '../Button';
import Text from '../Text';
import { D2CTheme } from '../ThemeProvider';
import { ButtonWrapper, Copy, Wrapper } from './styles';
const MarketingBanner = ({ headingCopy, subheadingCopy, buttonCopy, isLoading = false, onPress, skipAnimation = false, }) => {
    const [isMounted, setIsMounted] = useState(skipAnimation);
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsMounted(true);
        }, 50);
        return () => clearTimeout(timer);
    }, []);
    return (_jsx(ThemeProvider, { theme: D2CTheme, children: _jsxs(Wrapper, { "$isMounted": isMounted, children: [_jsxs(Copy, { children: [_jsx(Text, { noMargin: true, el: "h3", size: FontSizes.base, weight: FontWeights.Demi, children: headingCopy }), _jsx(Text, { noMargin: true, el: "p", size: FontSizes.base, children: subheadingCopy })] }), _jsx(ButtonWrapper, { children: _jsx(Button, { fullWidth: true, maxWidth: "192px", backgroundColor: "white", textColor: "blue2", loaderColor: "blue2", onPress: onPress, isLoading: isLoading, children: buttonCopy }) })] }) }));
};
export default MarketingBanner;
//# sourceMappingURL=index.js.map